var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"quote-block"},[_c('p',[_vm._v("“"+_vm._s(_vm.quote)+"”")]),(_vm.attribution)?_c('cite',[_vm._v(_vm._s(_vm.attribution))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }